import { Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { flatMap } from "rxjs";
import { environment } from "../../../../environments/environment";
import { Generate2FAReturnModel } from "../../../model/domain/Generate2FAReturnModel";
import { MFAValidateCodeModel } from "../../../model/domain/MFAValidateCodeModel";
import { AuthService } from "../../../services/auth.service";
import { LoaderService } from "../../../services/loader.service";
import { SnackbarService } from "../../../services/snackbar.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent {
  message: string;
  isAuthenticating = false;
  logoPath = `assets/img/${environment.name}/logo.png`;
  isNotProduction = environment.name != "production";
  shouldShowLogin = true;
  has2fa = false;
  generate2FAReturnModel: Generate2FAReturnModel = new Generate2FAReturnModel();

  credentials = {
    loginAlias: "",
    password: "",
    rememberMe: false,
    code: "",
    id: "",
    mfaValidationKey: "",
  };

  // FORM CONTROLS
  username = new FormControl("", [
    Validators.required,
    Validators.minLength(3),
  ]);
  password = new FormControl("", [
    Validators.required,
    Validators.minLength(4),
  ]);
  participante = new FormControl("", Validators.required);

  // FORM GROUPS
  login = new FormGroup({
    username: this.username,
    password: this.password,
  });

  constructor(
    private authService: AuthService,
    private router: Router,
    private snackBarService: SnackbarService,
    private loaderService: LoaderService
  ) {}

  signin() {
    this.loaderService.addLoader();
    this.username.markAsDirty();
    this.password.markAsDirty();

    if (!this.login.valid) {
      this.loaderService.removeLoader();

      return;
    }

    this.isAuthenticating = true;
    this.authService.login(this.username.value, this.password.value).subscribe(
      (result) => {
        this.isAuthenticating = false;
        this.loaderService.removeLoader();

        if (result) {
          this.credentials.id = result.userId;
          this.credentials.mfaValidationKey = result.mfaValidationKey;

          if (result.passwordResetHash) {
            this.router.navigateByUrl(
              `/password-reset/${this.username.value}/${result.passwordResetHash}`
            );
            return;
          }

          if (!result.hasMFAEnabled) {
            this.generateQrCode();
          } else {
            this.has2fa = true;
            this.shouldShowLogin = false;
          }

          return;
        }

        this.snackBarService.open("Usuário ou senha inválidos", "OK");
      },
      (result) => {
        this.isAuthenticating = false;
        this.loaderService.removeLoader();
        if (result.status === 400 && result.error) {
          this.snackBarService.open(result.error.message, "OK");
        } else if (result.message) {
          this.snackBarService.open(result.message, "OK");
        } else if (result.error) {
          const {
            error: { message },
          } = result;
          this.snackBarService.open(message, "OK");
        }
      }
    );
  }

  copyCode() {
    let selBox = document.createElement("textarea");
    selBox.value =
      this.generate2FAReturnModel.code != null
        ? this.generate2FAReturnModel.code
        : "";
    this.snackBarService.open("Código copiado", "OK");
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand("copy");
    document.body.removeChild(selBox);
  }

  sendCode() {
    let model = new MFAValidateCodeModel();

    model.code = this.credentials.code;
    model.mfaValidationKey = this.credentials.mfaValidationKey;
    model.userId = this.credentials.id;

    this.authService
      .validateMFACode(model)
      .pipe(flatMap(() => this.authService.roles()))
      .subscribe(
        (result) => {
          if (result) {
            this.shouldShowLogin = false;
            this.has2fa = true;
            this.router.navigateByUrl("/");
          }
        },
        (result) => {
          this.snackBarService.open(result.error, "OK");
        }
      );
  }

  generateQrCode() {
    let model = new MFAValidateCodeModel();

    model.code = this.credentials.code;
    model.mfaValidationKey = this.credentials.mfaValidationKey;
    model.userId = this.credentials.id;

    this.authService.generateQrCode(model).subscribe((result) => {
      this.generate2FAReturnModel.path = result.path;
      this.generate2FAReturnModel.code = result.code;
      this.shouldShowLogin = false;
      this.has2fa = false;
    });
  }

  continue() {
    this.has2fa = true;
  }

  sendCodeDisabled() {
    return this.credentials.code == null || this.credentials.code == "";
  }
}
